export const SET_PROSPECTIVE_STUDENTS = "SET_PROSPECTIVE_STUDENTS";
export const SET_PARENTS_OF_PROSPECTS = "SET_PARENTS_OF_PROSPECTS";
export const SET_CURRENT_STUDENT = "SET_CURRENT_STUDENT";
export const SET_ALUMNI = "SET_ALUMNI";
export const SET_FACULTY = "SET_FACULTY";
export const SET_GUIDANCE_COUNSELOR = "SET_GUIDANCE_COUNSELOR";
export const SET_VETERAN = "SET_VETERAN";
export const SET_VISITOR_TYPE_STATE = "SET_VISITOR_TYPE_STATE";